module.exports = __webpack_public_path__ + "img/f60.37383891.png";